import script from "./EditTextForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTextForm.vue?vue&type=script&setup=true&lang=js"

import "./EditTextForm.vue?vue&type=style&index=0&id=f3028402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3028402"]])

export default __exports__